var React = require('react');

function ArrowRightPrimaryInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 8.50004L6.5 3.88124L6.5 13.1188L11 8.50004Z","fill":"#40196D"}));
}

ArrowRightPrimaryInline.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = ArrowRightPrimaryInline;

ArrowRightPrimaryInline.default = ArrowRightPrimaryInline;
